import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColorSelect = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "24px",
	height: "24px",
	viewBox: "0 -960 960 960",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "none",
		fill: "currentColor",
		d: "M80 0m140-280 210-560h100l210 560h-96l-50-144H368l-52 144h-96Zm176-224h168l-82-232h-4l-82 232Z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "selected-color",
		d: "M80 0v-160h800V0H80"
	})]
});
export default SvgColorSelect;
